const DOUBLE = 2

const MAX_SIZES = 5.5
const EXTRA_VISIBLE_MARGIN = 2
const PADDING = 2

interface GetListHeight {
	sizesLength: number
	isSelectedSize: boolean
	itemHeight: number
}

export const getListHeight = ({
	sizesLength,
	isSelectedSize,
	itemHeight,
}: GetListHeight): number => {
	if (isSelectedSize) {
		return itemHeight + PADDING * DOUBLE
	}

	return sizesLength > MAX_SIZES
		? MAX_SIZES * itemHeight + EXTRA_VISIBLE_MARGIN + PADDING
		: sizesLength * itemHeight + PADDING * DOUBLE
}
